import { Reference, SuggestedPrompt } from '../../../common/ai.dictionary'
import { AiAgent } from '../../../common/ai.dictionary'

export const extract_author = (messagePayload: any): string => {
  try {
    if (messagePayload.agent) {
      return messagePayload.agent
    } else {
      return ''
    }
  } catch (e) {
    console.error('error parsing author', e, messagePayload)
    return 'Error parsing author'
  }
}

export const extract_next_steps = (messagePayload: any): string => {
  try {
    if (messagePayload.answer?.ai_classify) {
      const nextSteps = messagePayload.answer.ai_classify.next_steps
        ? '<br/> <div class="bg-neutral-900 text-sm p-2 rounded"> <i class="ph ph-info mr-1"></i> <b>Identified next steps:</b> <br/>' +
          messagePayload.answer.ai_classify.next_steps +
          '</div> <br/>'
        : ''
      return nextSteps
    }
    if (messagePayload.answer?.greetings && messagePayload.answer?.greetings?.type === 'continue') {
      const nextSteps = messagePayload.answer.greetings.next_steps
        ? '<br/> <div class="bg-neutral-900 text-sm p-2 rounded"> <i class="ph ph-info mr-1"></i> <b>Identified next steps:</b> <br/>' +
          messagePayload.answer.greetings.next_steps +
          '</div> <br/>'
        : ''
      return nextSteps
    }
    return ''
  } catch (e) {
    console.error('error parsing next steps', e, messagePayload)
    return ''
  }
}

export const extract_thinking = (messagePayload: any): string => {
  try {
    if (messagePayload.answer?.plan_described) {
      return messagePayload.answer.plan_described || ''
    }
    return null
  } catch (e) {
    console.error('error parsing thinking', e, messagePayload)
    return null
  }
}

export const extract_message = (messagePayload: any): string => {
  try {
    if (messagePayload.answer) {
      if (messagePayload.answer.actions && messagePayload.answer.actions.message) {
        return messagePayload.answer.actions.message || ''
      } else if (
        messagePayload.answer.greetings &&
        messagePayload.answer.greetings?.type === 'chat'
      ) {
        return messagePayload.answer.greetings.message || ''
      } else if (messagePayload.answer.ai_classify) {
        const message = messagePayload.answer.ai_classify.summary
          ? messagePayload.answer.ai_classify.summary
          : ''
        return message
      } else if (messagePayload.answer.respond && messagePayload.answer.respond.response) {
        return messagePayload.answer.respond.response || ''
      } else if (
        messagePayload.answer?.business_rule &&
        messagePayload.answer?.business_rule?.explanation
      ) {
        return messagePayload.answer.business_rule.explanation || ''
      } else if (messagePayload.answer.summary) {
        return messagePayload.answer.summary || ''
      } else if (messagePayload.answer.next_steps?.summary) {
        return messagePayload.answer.next_steps.summary || ''
      } else if (messagePayload.answer.generated_prompt?.description) {
        return messagePayload.answer.generated_prompt.description || ''
      } else if (
        messagePayload.answer.automate?.benefits ||
        messagePayload.answer.automate?.description
      ) {
        return (
          (messagePayload.answer.automate.description || '') +
          '<br/> <br/>' +
          ('**Benefits:** ' + (messagePayload.answer.automate.benefits || ''))
        )
      } else {
        return ''
      }
    }
    return ''
  } catch (e) {
    console.error('error parsing message', e, messagePayload)
    return ''
  }
}

export const extract_automate = (messagePayload: any): any[] => {
  try {
    if (messagePayload.answer && messagePayload.answer.automate) {
      if (messagePayload.answer.automate?.agents) {
        return messagePayload.answer.automate.agents
      }
    }
    return []
  } catch (e) {
    console.error('error parsing automate', e, messagePayload)
    return []
  }
}

export const extract_prompts = (messagePayload: any): SuggestedPrompt[] => {
  try {
    if (messagePayload.answer && messagePayload.answer.actions) {
      if (messagePayload.answer.actions.prompts) {
        return messagePayload.answer.actions.prompts.map((prompt: any) => ({
          action: prompt.action,
          description: prompt.description,
          handled_by: prompt.handled_by,
        }))
      } else {
        return []
      }
    }
    if (messagePayload.answer && messagePayload.answer.follow_up_questions?.questions) {
      return messagePayload.answer.follow_up_questions.questions.map((question: string) => ({
        action: question,
        description: null,
        handled_by: AiAgent.ASSISTANT,
      }))
    }
  } catch (e) {
    console.error('error parsing message', e, messagePayload)
    return []
  }
}

export const extract_log = (messagePayload: any): any => {
  try {
    if (messagePayload.debug) {
      return messagePayload
    }
  } catch (e) {
    console.error('error parsing log', e, messagePayload)
    return 'Error parsing log'
  }
}

export const extract_sources = (messagePayload: any): Reference[] => {
  try {
    if (messagePayload.answer && messagePayload.answer.respond?.documents) {
      return messagePayload.answer.respond.documents.map((document: any) => ({
        link: document.link,
        title: document.title,
      }))
    }
  } catch (e) {
    console.error('error parsing sources', e, messagePayload)
    return []
  }
}

export const extract_end = (messagePayload: any): any => {
  try {
    if (messagePayload.end) {
      console.warn('end', messagePayload.end)
      return messagePayload.end
    }
  } catch (e) {
    console.error('error parsing log', e, messagePayload)
    return 'Error parsing log'
  }
}
